import cls from "classnames";
import { useEffect, useState } from "react";
import { TransferCalcRoundOptions } from "@/domains/transfer";
import { UserMemberOptionFormData } from "../types";
// components
import { Button, Divider, Form, Input, Select, Tabs } from "antd";
import { ToTopOutlined, VerticalAlignBottomOutlined } from "@ant-design/icons";

export const Step2Form: React.FC<{
  data: UserMemberOptionFormData;
  visible: boolean;
  onPrev: () => void;
  onNext: (data: UserMemberOptionFormData) => void;
  onCancel: () => void;
}> = ({ data, visible, onPrev, onNext, onCancel }) => {
  const [activeTabKey, setActiveTabKey] = useState("deposit");

  const [form] = Form.useForm<UserMemberOptionFormData>();

  const getDepositRateModeText = (value: number) => {
    if (value === 0) return "匯率";
    else if (value === 1) return "加減";
    return "";
  };

  const [depositRateModeText, setDepositRateModeText] = useState<string>(
    getDepositRateModeText(data.member_deposit_rate_mode)
  );

  const handleDepositRateModeChange = (value: number) => {
    setDepositRateModeText(getDepositRateModeText(value));
  };

  const getDepositChargeFrom = (value: number) => {
    return value;
  };

  const [depositChargeFrom, setDepositChargeFrom] = useState<number>(
    getDepositChargeFrom(data.member_deposit_charge_from)
  );

  const handleDepositChargeFromChange = (value: number) => {
    setDepositChargeFrom(getDepositChargeFrom(value));
  };

  const getDepositChargeMode = (value: number) => {
    return value;
  };

  const [depositChargeMode, setDepositChargeMode] = useState<number>(
    getDepositChargeMode(data.member_deposit_charge_mode)
  );

  const handleDepositChargeModeChange = (value: number) => {
    setDepositChargeMode(getDepositChargeMode(value));
  };

  const getWithdrawRateModeText = (value: number) => {
    if (value === 0) return "匯率";
    else if (value === 1) return "加減";
    return "";
  };

  const [withdrawRateModeText, setWithdrawRateModeText] = useState<string>(
    getWithdrawRateModeText(data.member_withdraw_rate_mode)
  );

  const handleWithdrawRateModeChange = (value: number) => {
    setWithdrawRateModeText(getWithdrawRateModeText(value));
  };

  const getWithdrawChargeFrom = (value: number) => {
    return value;
  };

  const [withdrawChargeFrom, setWithdrawChargeFrom] = useState<number>(
    getWithdrawChargeFrom(data.member_withdraw_charge_from)
  );

  const handleWithdrawChargeFromChange = (value: number) => {
    setWithdrawChargeFrom(getDepositChargeFrom(value));
  };

  const getWithdrawChargeMode = (value: number) => {
    return value;
  };

  const [withdrawChargeMode, setWithdrawChargeMode] = useState<number>(
    getWithdrawChargeMode(data.member_withdraw_charge_mode)
  );

  const handleWithdrawChargeModeChange = (value: number) => {
    setWithdrawChargeMode(getDepositChargeMode(value));
  };

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(data);
  }, [data, form]);

  return (
    <Form
      form={form}
      labelCol={{ span: 6 }}
      className={cls(["mt:16", { hidden: !visible }])}
      onFinish={(values) => {
        onNext(values);
      }}
    >
      <Tabs
        className="pl:16"
        activeKey={activeTabKey}
        items={[
          {
            label: "會員存單",
            key: "deposit",
            forceRender: true,
            icon: <VerticalAlignBottomOutlined />,
            children: (
              <>
                <Form.Item label="會員存單回調" className="mb:0">
                  <div className="flex">
                    <Form.Item
                      label=""
                      colon={false}
                      required={false}
                      className="flex:1"
                      name="member_deposit_callback"
                    >
                      <Input placeholder="請輸入會員存單回調" />
                    </Form.Item>
                  </div>
                </Form.Item>

                <Form.Item label="會員存單失效時間" className="mb:0">
                  <div className="flex">
                    <Form.Item className="flex:1" name="member_deposit_expired">
                      <Input
                        type="number"
                        placeholder="請輸入會員存單失效時間"
                      />
                    </Form.Item>
                    <div className="h:30 pl:8 flex jc:center ai:center">分</div>
                  </div>
                </Form.Item>

                <Form.Item label="會員存單幣值" className="mb:0">
                  <div className="flex">
                    <Form.Item
                      label=""
                      colon={false}
                      required={false}
                      className="flex:1"
                      name="member_deposit_currency"
                    >
                      <Input placeholder="請輸入會員存單幣值" />
                    </Form.Item>
                  </div>
                </Form.Item>

                <Form.Item label="會員存單金額計算" className="mb:0">
                  <div className="flex">
                    <Form.Item
                      label=""
                      colon={false}
                      required={false}
                      className="flex:1"
                      name="member_deposit_round"
                    >
                      <Select>
                        {TransferCalcRoundOptions.map(({ label, value }) => (
                          <Select.Option value={value} key={value}>
                            {label}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                </Form.Item>

                <Form.Item label="會員存單匯率" className="mb:0">
                  <div className="flex">
                    <Form.Item
                      label=""
                      colon={false}
                      className="flex:1"
                      name="member_deposit_rate_mode"
                    >
                      <Select onChange={handleDepositRateModeChange}>
                        <Select.Option value={0}>固定匯率</Select.Option>
                        <Select.Option value={1}>
                          跟隨幣託 USDT-TWD
                        </Select.Option>
                        <Select.Option value={11}>
                          跟隨歐易 USDT-VND
                        </Select.Option>
                      </Select>
                    </Form.Item>

                    <div className="h:30 px:8 flex jc:center ai:center">
                      {depositRateModeText}
                    </div>

                    <Form.Item
                      label=""
                      colon={false}
                      className="flex:1"
                      name="member_deposit_rate_data"
                    >
                      <Input type="number" placeholder="請輸入會員存單匯率" />
                    </Form.Item>
                  </div>
                </Form.Item>

                <Form.Item label="會員存單手續費" className="mb:0">
                  <div className="flex ai:center gap:16">
                    <Form.Item
                      className="flex:1"
                      name="member_deposit_charge_from"
                    >
                      <Select onChange={handleDepositChargeFromChange}>
                        <Select.Option value={0}>從商戶</Select.Option>
                        <Select.Option value={1}>從會員</Select.Option>
                      </Select>
                    </Form.Item>
                    {depositChargeFrom === 0 && (
                      <Form.Item
                        className="flex:1"
                        name="member_deposit_charge_time"
                      >
                        <Select>
                          <Select.Option value={0}>前收</Select.Option>
                          <Select.Option value={1}>後收</Select.Option>
                        </Select>
                      </Form.Item>
                    )}
                    <Form.Item
                      label=""
                      colon={false}
                      required={false}
                      className="flex:1"
                      name="member_deposit_charge_mode"
                    >
                      <Select onChange={handleDepositChargeModeChange}>
                        <Select.Option value={0}>顆數</Select.Option>
                        <Select.Option value={1}>比例</Select.Option>
                        <Select.Option value={2}>顆數+比例</Select.Option>
                      </Select>
                    </Form.Item>

                    {depositChargeMode === 0 && (
                      <Form.Item className="mb:0">
                        <div className="flex">
                          <Form.Item
                            className="flex:1"
                            name="member_deposit_charge_data"
                          >
                            <Input
                              type="number"
                              placeholder="請輸入會員存單手續費"
                            />
                          </Form.Item>
                          <div className="h:30 pl:8 flex jc:center ai:center">
                            USDT
                          </div>
                        </div>
                      </Form.Item>
                    )}

                    {depositChargeMode === 1 && (
                      <Form.Item className="mb:0">
                        <div className="flex">
                          <Form.Item
                            className="flex:1"
                            name="member_deposit_charge_rate"
                          >
                            <Input
                              type="number"
                              placeholder="請輸入會員存單手續費"
                            />
                          </Form.Item>
                          <div className="h:30 pl:8 flex jc:center ai:center">
                            %
                          </div>
                        </div>
                      </Form.Item>
                    )}

                    {depositChargeMode === 2 && (
                      <Form.Item className="mb:0">
                        <div className="flex">
                          <Form.Item
                            className="flex:1"
                            name="member_deposit_charge_data"
                          >
                            <Input type="number" placeholder="請輸入手續費" />
                          </Form.Item>
                          <div className="h:30 px:8 flex jc:center ai:center">
                            USDT +
                          </div>
                          <Form.Item
                            className="flex:1"
                            name="member_deposit_charge_rate"
                          >
                            <Input type="number" placeholder="請輸入手續費" />
                          </Form.Item>
                          <div className="h:30 pl:8 flex jc:center ai:center">
                            %
                          </div>
                        </div>
                      </Form.Item>
                    )}
                  </div>
                </Form.Item>

                <Form.Item label="會員存單上下限額" className="mb:0">
                  <div className="flex">
                    <Form.Item
                      className="flex:1"
                      name="member_deposit_amount_min"
                    >
                      <Input type="number" placeholder="請輸入會員存單下限" />
                    </Form.Item>

                    <div className="h:30 px:8 flex jc:center ai:center">
                      USDT ~
                    </div>

                    <Form.Item
                      className="flex:1"
                      name="member_deposit_amount_max"
                    >
                      <Input type="number" placeholder="請輸入會員存單上限" />
                    </Form.Item>

                    <div className="h:30 px:8 flex jc:center ai:center">
                      USDT
                    </div>
                  </div>
                </Form.Item>

                <Form.Item className="mb:0" label="會員存單封鎖門檻">
                  <div className="flex">
                    <div className="h:30 pr:8 flex jc:center ai:center">
                      連續
                    </div>

                    <Form.Item
                      className="flex:1"
                      name="member_deposit_block_seconds"
                    >
                      <Input type="number" />
                    </Form.Item>

                    <div className="h:30 px:8 flex jc:center ai:center white-space:nowrap">
                      秒內發生
                    </div>

                    <Form.Item
                      className="flex:1"
                      name="member_deposit_block_times"
                    >
                      <Input type="number" />
                    </Form.Item>

                    <div className="h:30 pl:8 flex jc:center ai:center">次</div>
                  </div>
                </Form.Item>

                <Form.Item label="會員存單封鎖時間" className="mb:0">
                  <div className="flex">
                    <Form.Item
                      className="flex:1"
                      name="member_deposit_block_span"
                    >
                      <Input
                        type="number"
                        placeholder="請輸入會員存單封鎖時間"
                      />
                    </Form.Item>
                    <div className="h:30 pl:8 flex jc:center ai:center">
                      分鐘
                    </div>
                  </div>
                </Form.Item>
              </>
            ),
          },
          {
            label: "會員提單",
            key: "withdraw",
            forceRender: true,
            icon: <ToTopOutlined />,
            children: (
              <>
                <Form.Item label="會員提單回調" className="mb:0">
                  <div className="flex">
                    <Form.Item
                      label=""
                      colon={false}
                      required={false}
                      className="flex:1"
                      name="member_withdraw_callback"
                    >
                      <Input placeholder="請輸入會員提單回調" />
                    </Form.Item>
                  </div>
                </Form.Item>

                <Form.Item label="會員提單失效時間" className="mb:0">
                  <div className="flex">
                    <Form.Item
                      className="flex:1"
                      name="member_withdraw_expired"
                    >
                      <Input
                        type="number"
                        placeholder="請輸入會員提單失效時間"
                      />
                    </Form.Item>
                    <div className="h:30 pl:8 flex jc:center ai:center">分</div>
                  </div>
                </Form.Item>

                <Form.Item label="會員提單幣值" className="mb:0">
                  <div className="flex">
                    <Form.Item
                      label=""
                      colon={false}
                      required={false}
                      className="flex:1"
                      name="member_withdraw_currency"
                    >
                      <Input placeholder="請輸入會員提單幣值" />
                    </Form.Item>
                  </div>
                </Form.Item>

                <Form.Item label="會員提單金額計算" className="mb:0">
                  <div className="flex">
                    <Form.Item
                      label=""
                      colon={false}
                      required={false}
                      className="flex:1"
                      name="member_withdraw_round"
                    >
                      <Select>
                        {TransferCalcRoundOptions.map(({ label, value }) => (
                          <Select.Option value={value} key={value}>
                            {label}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                </Form.Item>

                <Form.Item label="會員提單匯率" className="mb:0">
                  <div className="flex">
                    <Form.Item
                      label=""
                      colon={false}
                      className="flex:1"
                      name="member_withdraw_rate_mode"
                    >
                      <Select onChange={handleWithdrawRateModeChange}>
                        <Select.Option value={0}>固定匯率</Select.Option>
                        <Select.Option value={1}>
                          跟隨幣託 USDT-TWD
                        </Select.Option>
                        <Select.Option value={11}>
                          跟隨歐易 USDT-VND
                        </Select.Option>
                      </Select>
                    </Form.Item>

                    <div className="h:30 px:8 flex jc:center ai:center">
                      {withdrawRateModeText}
                    </div>

                    <Form.Item
                      label=""
                      colon={false}
                      className="flex:1"
                      name="member_withdraw_rate_data"
                    >
                      <Input type="number" placeholder="請輸入會員提單匯率" />
                    </Form.Item>
                  </div>
                </Form.Item>

                <Form.Item label="會員提單手續費" className="mb:0">
                  <div className="flex ai:center gap:16">
                    <Form.Item
                      className="flex:1"
                      name="member_withdraw_charge_from"
                    >
                      <Select onChange={handleWithdrawChargeFromChange}>
                        <Select.Option value={0}>從商戶</Select.Option>
                        <Select.Option value={1}>從會員</Select.Option>
                      </Select>
                    </Form.Item>
                    {withdrawChargeFrom === 0 && (
                      <Form.Item
                        className="flex:1"
                        name="member_withdraw_charge_time"
                      >
                        <Select>
                          <Select.Option value={0}>前收</Select.Option>
                          <Select.Option value={1}>後收</Select.Option>
                        </Select>
                      </Form.Item>
                    )}
                    <Form.Item
                      label=""
                      colon={false}
                      className="flex:1"
                      name="member_withdraw_charge_mode"
                    >
                      <Select onChange={handleWithdrawChargeModeChange}>
                        <Select.Option value={0}>顆數</Select.Option>
                        <Select.Option value={1}>比例</Select.Option>
                        <Select.Option value={2}>顆數+比例</Select.Option>
                      </Select>
                    </Form.Item>

                    {withdrawChargeMode === 0 && (
                      <Form.Item className="mb:0">
                        <div className="flex">
                          <Form.Item
                            className="flex:1"
                            name="member_withdraw_charge_data"
                          >
                            <Input
                              type="number"
                              placeholder="請輸入會員提單手續費"
                            />
                          </Form.Item>
                          <div className="h:30 pl:8 flex jc:center ai:center">
                            USDT
                          </div>
                        </div>
                      </Form.Item>
                    )}

                    {withdrawChargeMode === 1 && (
                      <Form.Item className="mb:0">
                        <div className="flex">
                          <Form.Item
                            className="flex:1"
                            name="member_withdraw_charge_rate"
                          >
                            <Input
                              type="number"
                              placeholder="請輸入會員存單手續費"
                            />
                          </Form.Item>
                          <div className="h:30 pl:8 flex jc:center ai:center">
                            %
                          </div>
                        </div>
                      </Form.Item>
                    )}

                    {withdrawChargeMode === 2 && (
                      <Form.Item className="mb:0">
                        <div className="flex">
                          <Form.Item
                            className="flex:1"
                            name="member_withdraw_charge_data"
                          >
                            <Input type="number" placeholder="請輸入手續費" />
                          </Form.Item>
                          <div className="h:30 px:8 flex jc:center ai:center">
                            USDT +
                          </div>
                          <Form.Item
                            className="flex:1"
                            name="member_withdraw_charge_rate"
                          >
                            <Input type="number" placeholder="請輸入手續費" />
                          </Form.Item>
                          <div className="h:30 pl:8 flex jc:center ai:center">
                            %
                          </div>
                        </div>
                      </Form.Item>
                    )}
                  </div>
                </Form.Item>

                <Form.Item label="會員提單上下限額" className="mb:0">
                  <div className="flex">
                    <Form.Item
                      className="flex:1"
                      name="member_withdraw_amount_min"
                    >
                      <Input type="number" placeholder="請輸入會員提單下限" />
                    </Form.Item>

                    <div className="h:30 px:8 flex jc:center ai:center">
                      USDT ~
                    </div>

                    <Form.Item
                      className="flex:1"
                      name="member_withdraw_amount_max"
                    >
                      <Input type="number" placeholder="請輸入會員提單上限" />
                    </Form.Item>

                    <div className="h:30 px:8 flex jc:center ai:center">
                      USDT
                    </div>
                  </div>
                </Form.Item>

                <Form.Item className="mb:0" label="會員提單封鎖門檻">
                  <div className="flex">
                    <div className="h:30 pr:8 flex jc:center ai:center">
                      連續
                    </div>

                    <Form.Item
                      className="flex:1"
                      name="member_withdraw_block_seconds"
                    >
                      <Input type="number" />
                    </Form.Item>

                    <div className="h:30 px:8 flex jc:center ai:center white-space:nowrap">
                      秒內發生
                    </div>

                    <Form.Item
                      className="flex:1"
                      name="member_withdraw_block_times"
                    >
                      <Input type="number" />
                    </Form.Item>

                    <div className="h:30 pl:8 flex jc:center ai:center">次</div>
                  </div>
                </Form.Item>

                <Form.Item className="mb:0" label="會員提單封鎖時間">
                  <div className="flex">
                    <Form.Item
                      className="flex:1"
                      name="member_withdraw_block_span"
                    >
                      <Input
                        type="number"
                        placeholder="請輸入會員提單封鎖時間"
                      />
                    </Form.Item>
                    <div className="h:30 pl:8 flex jc:center ai:center">
                      分鐘
                    </div>
                  </div>
                </Form.Item>
              </>
            ),
          },
        ]}
        onChange={setActiveTabKey}
      ></Tabs>

      <Divider />

      <Form.Item>
        <div className="flex jc:end gap:8">
          <Button htmlType="button" onClick={onCancel}>
            取消
          </Button>
          <Button htmlType="button" onClick={onPrev}>
            上一步
          </Button>
          <Button type="primary" htmlType="submit">
            下一步
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
};
